import { useQuery } from "react-query";
import { listOpportunities } from "../../../api/server";
import { useState, useEffect } from "react";

export const useOpportunitiesData = (page, scopePrefix) => {
  const [data, setData] = useState(null);
  const { isLoading, error, refetch } = useQuery(
    [{ page }],
    async () => {
      const result = await listOpportunities({ ...page, scopePrefix });
      setData(result.data);
      return result.data;
    },
    {
      keepPreviousData: true,
      staleTime: 0, //no cached time
      enabled: page !== null,
    }
  );

  useEffect(() => {
    setData(null); // reset data when page changes
  }, [page]);

  return { data, isLoading, error, refetch };
};
